<form *ngIf="workerTimeRangeFormGroup" [formGroup]="workerTimeRangeFormGroup">
    <div class="card mt-2 ">        
        <div class="formgrid grid pt-2">
            <div class="col input-field ">
                <label for="startHour">Desde</label>
                <p-calendar [firstDayOfWeek]="1" inputId="startHour" [timeOnly]="true" appendTo="body" formControlName="startHour"
                    d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="endHour">Hasta</label>
                <p-calendar [firstDayOfWeek]="1" inputId="endHour" formControlName="endHour" [timeOnly]="true" appendTo="body"
                    d-form-field-error />
            </div>
        </div>
        <div class="flex flex-wrap justify-content-center gap-3 pt-4">
            <div class="flex align-items-center">
                <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="monday" [binary]="true" value="true" />Lunes</label>
            </div>
            <div class="flex align-items-center">
                <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="tuesday" [binary]="true" value="true" />Martes</label>
            </div>
            <div class="flex align-items-center">
                <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="wednesday" [binary]="true" value="true" />Miercoles</label>
            </div>
            <div class="flex align-items-center">
                <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="thursday" [binary]="true" value="true" />Jueves</label>
            </div>
            <div class="flex align-items-center">
                <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="friday" [binary]="true" value="true" />Viernes</label>
            </div>
            <div class="flex align-items-center">
                <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="saturday" [binary]="true" value="true" />Sábado</label>
            </div>
            <div class="flex align-items-center">
                <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="sunday" [binary]="true" value="true" />Domingo</label>
            </div>
        </div>
        <div class="mt-6 flex gap-2 justify-content-end ">
            <p-button label="Eliminar" *ngIf="workerTimeRange.id && allowDelete" icon="pi pi-trash"
                styleClass="p-button-danger" (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </div>
</form>